import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { getVideo } from '../../../../utils/videoDB';

const AirtableVideoPlayer = ({
  videoRef,
  videoKey,
  handleVideoPlayPage,
  handleVideoEnd,
  removeWhiteFlashOnVideo,
}) => {
  const [videoSrc, setVideoSrc] = useState('');

  useEffect(() => {
    let objectUrl = null;

    const fetchAndLoadVideo = async () => {
      try {
        // const splashdecodedUrl = decodeURIComponent(videoKey.id);
        // const splashfileName = splashdecodedUrl.split('/').pop();
        const result = await getVideo(videoKey.id);
        const blob = result?.blob;

        if (blob && blob instanceof Blob) {
          objectUrl = URL.createObjectURL(blob);
          setVideoSrc(objectUrl); // Set to <video src>
          console.log('blobUrl', objectUrl);
        } else {
          console.error('Invalid blob:', blob);
          setVideoSrc(videoKey.videoUrl); // fallback
        }
      } catch (err) {
        console.error('Error loading video:', err);
      }
    };

    fetchAndLoadVideo();
    console.log('updated');

    return () => {
      if (videoRef?.current) {
        videoRef.current.pause();
        videoRef.current.removeAttribute('src'); // Unset the video source first
        videoRef.current.load(); // Forces the video to unload
      }
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl); // Now revoke
      }
      setVideoSrc('');
    };
  }, [videoKey]);

  const motionProps = removeWhiteFlashOnVideo
    ? {}
    : {
        initial: { opacity: 0 },
        animate: { opacity: 1 },
        exit: { opacity: 0 },
        transition: { duration: 2 },
      };
  return (
    <video
      ref={videoRef}
      className="videoEle show"
      src={videoSrc}
      muted
      preload="auto"
      autoPlay
      onPlay={handleVideoPlayPage}
      onEnded={handleVideoEnd}
      loop={false}
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        objectFit: 'cover',
        zIndex: 1,
      }}
      {...motionProps}
    />
  );
};

export default AirtableVideoPlayer;
